import { createFileRoute } from '@tanstack/react-router';
import { AdminPickupCostCbmPage } from '@/features/admin/admin-pickup-cost-cbm-page';

export const Route = createFileRoute('/admin/pickup-cost-cbm/')({
  component: AdminPickupCostCbmRoute,
});

function AdminPickupCostCbmRoute() {
  return <AdminPickupCostCbmPage />;
}
